<template>
  <div class="box-sizing add_control">
    <div class="add_control_position add_control_position_new">
      <h6 class="title">添加控件</h6>
      <div class="el-scrollbar">
        <div class="el-scrollbar__wrap el-scrollbar__wrap--hidden-default">
          <div class="el-scrollbar__div">
            <div class="add_btn_list">
              <div
                v-for="(item, index) in dataList"
                :data-type="item.type"
                :key="index"
              >
                <div class="add_title" v-if="item.title">
                  <p>{{ item.title }}</p>
                  <div
                    v-if="index === 0 && questionType !== 3"
                    style="margin-right: 20px; color: #3a60ff; cursor: pointer"
                    @click.stop="handleImportClick"
                  >
                    题库导入
                  </div>
                </div>

                <div
                  class="component-item css3 box-sizing btn_item cy_picture_hover"
                  @click.stop="handleComponentClick(item, index)"
                >
                  <div
                    class="content"
                    style="display: flex; height: 100%; align-items: center"
                  >
                    <img class="colourless" :src="item.colourless" alt="" />
                    <img class="color" :src="item.color" alt="" />
                    <span>{{ item.name }}</span>
                  </div>
                  <el-popover placement="right-start" trigger="hover">
                    <div class="cy_prediv_hover">
                      <img :src="item.hover" alt="" />
                    </div>
                    <div slot="reference" class="oezo_add_tips">
                      <img
                        class="oezo_add_tips0"
                        src="@/assets/images/add_icon/icon_tips.svg"
                        alt=""
                      />
                      <img
                        class="oezo_add_tips1"
                        src="@/assets/images/add_icon/icon_tips0.svg"
                        alt=""
                      />
                    </div>
                  </el-popover>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入addQuestion
export default {
  name: "AddControl",
  props: {
    questionType: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      wjComponents: [
        {
          type: 1,
          name: "单选",
          colourless: require("@/assets/images/add_icon/add_btn_icon110.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon111.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn0.svg"),
          title: "基础题型",
        },
        {
          type: 2,
          name: "多选",
          colourless: require("@/assets/images/add_icon/add_btn_icon120.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon121.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn1.svg"),
        },
        {
          type: 3,
          name: "填空",
          colourless: require("@/assets/images/add_icon/add_btn_icon220.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon221.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn4.svg"),
        },
        {
          type: 4,
          name: "多项填空",
          colourless: require("@/assets/images/add_icon/add_btn_icon230.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon231.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn5.svg"),
        },
        {
          type: 5,
          name: "下拉",
          colourless: require("@/assets/images/add_icon/add_btn_icon130.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon131.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn2.svg"),
        },
        {
          type: 6,
          name: "NPS",
          colourless: require("@/assets/images/add_icon/add_btn_icon350.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon351.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn54.png"),
        },
        {
          type: 7,
          name: "投票",
          colourless: require("@/assets/images/add_icon/add_btn_icon440.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon441.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn59.png"),
        },
        {
          type: 8,
          name: "排序",
          colourless: require("@/assets/images/add_icon/add_btn_icon450.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon451.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn11.png"),
        },
        {
          type: 9,
          name: "备注说明",
          colourless: require("@/assets/images/add_icon/add_btn_icon410.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon411.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn8.svg"),
        },
        {
          type: 10,
          name: "分数评定",
          colourless: require("@/assets/images/add_icon/add_btn_icon310.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon311.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn6.svg"),
        },
        {
          type: 11,
          name: "问答",
          colourless: require("@/assets/images/add_icon/add_btn_icon210.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon211.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn3.svg"),
        },
        {
          type: 12,
          name: "权重评分",
          colourless: require("@/assets/images/add_icon/add_btn_icon12.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon13.svg"),
          hover: require("@/assets/images/add_icon/hover-iocnQZ.png"),
        },
        {
          type: 13,
          name: "评星",
          colourless: require("@/assets/images/add_icon/add_btn_icon320.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon321.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn7.svg"),
        },
        {
          type: 23,
          name: "图片上传",
          colourless: require("@/assets/images/add_icon/add_btn_icon540.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon541.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn60.svg"),
        },
        {
          type: 24,
          name: "MaxDiff",
          colourless: require("@/assets/images/add_icon/add_btn_icon532.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon533.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn61.png"),
        },
        {
          type: 25,
          name: "上传文件",
          colourless: require("@/assets/images/add_icon/add_btn_icon534.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon535.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn62.png"),
        },
        {
          type: 26,
          name: "下载附件",
          colourless: require("@/assets/images/add_icon/add_btn_icon536.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon537.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn63.png"),
        },
        {
          type: 27,
          name: "联级题",
          colourless: require("@/assets/images/add_icon/add_btn_icon538.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon539.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn64.png"),
        },
        {
          type: 33,
          name: "标题",
          colourless: require("@/assets/images/add_icon/add_btn_icon564.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon565.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn77.svg"),
        },
        {
          type: 34,
          name: "分页线",
          colourless: require("@/assets/images/add_icon/add_btn_icon566.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon567.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn78.svg"),
        },
        {
          type: 35,
          name: "矩阵单选",
          colourless: require("@/assets/images/add_icon/add_btn_icon568.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon569.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn74.svg"),
        },
        {
          type: 36,
          name: "矩阵多选",
          colourless: require("@/assets/images/add_icon/add_btn_icon570.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon571.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn75.svg"),
        },
        {
          type: 37,
          name: "图片单选",
          colourless: require("@/assets/images/add_icon/add_btn_icon572.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon573.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn72.svg"),
        },
        {
          type: 38,
          name: "图片多选",
          colourless: require("@/assets/images/add_icon/add_btn_icon574.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon575.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn73.svg"),
        },
        {
          type: 39,
          name: "图片/视频",
          colourless: require("@/assets/images/add_icon/add_btn_icon576.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon577.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn80.png"),
        },
        {
          type: 40,
          name: "签名",
          colourless: require("@/assets/images/add_icon/add_btn_icon578.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon579.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn71.svg"),
        },
        {
          type: 14,
          name: "姓名",
          colourless: require("@/assets/images/add_icon/add_btn_icon460.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon461.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn46.png"),
          title: "常用信息",
        },
        {
          type: 15,
          name: "性别",
          colourless: require("@/assets/images/add_icon/add_btn_icon470.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon471.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn47.png"),
        },
        {
          type: 16,
          name: "年龄",
          colourless: require("@/assets/images/add_icon/add_btn_icon480.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon481.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn48.png"),
        },
        {
          type: 17,
          name: "电话号",
          colourless: require("@/assets/images/add_icon/add_btn_icon490.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon491.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn49.png"),
        },
        {
          type: 18,
          name: "邮箱",
          colourless: require("@/assets/images/add_icon/add_btn_icon500.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon501.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn50.png"),
        },
        {
          type: 19,
          name: "日期",
          colourless: require("@/assets/images/add_icon/add_btn_icon510.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon511.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn51.png"),
        },
        {
          type: 20,
          name: "时间",
          colourless: require("@/assets/images/add_icon/add_btn_icon520.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon521.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn52.png"),
        },
        {
          type: 21,
          name: "地址",
          colourless: require("@/assets/images/add_icon/add_btn_icon530.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon531.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn53.png"),
        },
        {
          type: 29,
          name: "出生日期",
          colourless: require("@/assets/images/add_icon/add_btn_icon550.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon551.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn65.png"),
        },
        {
          type: 30,
          name: "身份证号",
          colourless: require("@/assets/images/add_icon/add_btn_icon552.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon553.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn66.png"),
        },
        {
          type: 31,
          name: "学历",
          colourless: require("@/assets/images/add_icon/add_btn_icon554.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon555.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn67.png"),
        },
        {
          type: 32,
          name: "微信号",
          colourless: require("@/assets/images/add_icon/add_btn_icon556.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon557.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn68.png"),
        },
        {
          type: 49,
          name: "自定义",
          colourless: require("@/assets/images/add_icon/add_btn_icon580.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon581.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn82.png"),
        },
      ],
      ksComponents: [
        {
          type: 1,
          name: "单选",
          colourless: require("@/assets/images/add_icon/add_btn_icon110.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon111.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn0.svg"),
          title: "基础题型",
        },
        {
          type: 2,
          name: "多选",
          colourless: require("@/assets/images/add_icon/add_btn_icon120.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon121.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn1.svg"),
        },
        {
          type: 22,
          name: "判断",
          colourless: require("@/assets/images/add_icon/add_btn_icon220.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon221.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn4.svg"),
        },
        {
          type: 3,
          name: "填空",
          colourless: require("@/assets/images/add_icon/add_btn_icon220.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon221.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn4.svg"),
        },
        {
          type: 4,
          name: "多项填空",
          colourless: require("@/assets/images/add_icon/add_btn_icon230.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon231.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn5.svg"),
        },
        {
          type: 11,
          name: "问答",
          colourless: require("@/assets/images/add_icon/add_btn_icon210.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon211.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn3.svg"),
        },
        {
          type: 23,
          name: "图片上传",
          colourless: require("@/assets/images/add_icon/add_btn_icon130.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon131.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn60.svg"),
        },
        {
          type: 28,
          name: "完形填空",
          colourless: require("@/assets/images/add_icon/add_btn_icon350.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon351.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn81.png"),
        },
        {
          type: 14,
          name: "姓名",
          colourless: require("@/assets/images/add_icon/add_btn_icon460.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon461.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn46.png"),
          title: "常用信息",
        },
        {
          type: 15,
          name: "性别",
          colourless: require("@/assets/images/add_icon/add_btn_icon470.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon471.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn47.png"),
        },
        {
          type: 16,
          name: "年龄",
          colourless: require("@/assets/images/add_icon/add_btn_icon480.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon481.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn48.png"),
        },
        {
          type: 17,
          name: "电话号",
          colourless: require("@/assets/images/add_icon/add_btn_icon490.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon491.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn49.png"),
        },
        {
          type: 18,
          name: "邮箱",
          colourless: require("@/assets/images/add_icon/add_btn_icon500.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon501.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn50.png"),
        },
        {
          type: 19,
          name: "日期",
          colourless: require("@/assets/images/add_icon/add_btn_icon510.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon511.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn51.png"),
        },
        {
          type: 20,
          name: "时间",
          colourless: require("@/assets/images/add_icon/add_btn_icon520.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon521.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn52.png"),
        },
        {
          type: 21,
          name: "地址",
          colourless: require("@/assets/images/add_icon/add_btn_icon530.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon531.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn53.png"),
        },
        {
          type: 29,
          name: "出生日期",
          colourless: require("@/assets/images/add_icon/add_btn_icon550.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon551.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn65.png"),
        },
        {
          type: 30,
          name: "身份证号",
          colourless: require("@/assets/images/add_icon/add_btn_icon552.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon553.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn66.png"),
        },
        {
          type: 31,
          name: "学历",
          colourless: require("@/assets/images/add_icon/add_btn_icon554.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon555.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn67.png"),
        },
        {
          type: 32,
          name: "微信号",
          colourless: require("@/assets/images/add_icon/add_btn_icon556.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon557.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn68.png"),
        },
        {
          type: 49,
          name: "自定义",
          colourless: require("@/assets/images/add_icon/add_btn_icon580.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon581.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn82.png"),
        },
      ],
      cpComponents: [
        {
          type: 43,
          name: "单选",
          colourless: require("@/assets/images/add_icon/add_btn_icon110.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon111.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn0.svg"),
          title: "基础题型",
        },
        {
          type: 44,
          name: "多选",
          colourless: require("@/assets/images/add_icon/add_btn_icon120.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon121.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn1.svg"),
        },
        {
          type: 45,
          name: "权重评分",
          colourless: require("@/assets/images/add_icon/add_btn_icon12.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon13.svg"),
          hover: require("@/assets/images/add_icon/hover-iocnQZ.png"),
        },
        {
          type: 46,
          name: "NPS",
          colourless: require("@/assets/images/add_icon/add_btn_icon350.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon351.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn54.png"),
        },
        {
          type: 47,
          name: "分数评定",
          colourless: require("@/assets/images/add_icon/add_btn_icon310.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon311.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn6.svg"),
        },
        {
          type: 48,
          name: "文本描述",
          colourless: require("@/assets/images/add_icon/add_btn_icon562.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon563.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn79.png"),
        },
        {
          type: 50,
          name: "矩阵单选",
          colourless: require("@/assets/images/add_icon/add_btn_icon568.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon569.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn74.svg"),
        },
        {
          type: 39,
          name: "图片/视频",
          colourless: require("@/assets/images/add_icon/add_btn_icon576.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon577.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn80.png"),
        },
        {
          type: 51,
          name: "音频",
          colourless: require("@/assets/images/add_icon/add_btn_icon582.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon583.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn83.png"),
        },
        {
          type: 14,
          name: "姓名",
          colourless: require("@/assets/images/add_icon/add_btn_icon460.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon461.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn46.png"),
          title: "常用信息",
        },
        {
          type: 15,
          name: "性别",
          colourless: require("@/assets/images/add_icon/add_btn_icon470.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon471.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn47.png"),
        },
        {
          type: 16,
          name: "年龄",
          colourless: require("@/assets/images/add_icon/add_btn_icon480.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon481.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn48.png"),
        },
        {
          type: 31,
          name: "学历",
          colourless: require("@/assets/images/add_icon/add_btn_icon554.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon555.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn67.png"),
        },
        {
          type: 19,
          name: "日期",
          colourless: require("@/assets/images/add_icon/add_btn_icon510.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon511.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn51.png"),
        },
        {
          type: 21,
          name: "地址",
          colourless: require("@/assets/images/add_icon/add_btn_icon530.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon531.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn53.png"),
        },
        {
          type: 41,
          name: "行业",
          colourless: require("@/assets/images/add_icon/add_btn_icon558.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon559.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn69.svg"),
        },
        {
          type: 42,
          name: "职业",
          colourless: require("@/assets/images/add_icon/add_btn_icon560.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon561.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn70.svg"),
        },
        {
          type: 49,
          name: "自定义",
          colourless: require("@/assets/images/add_icon/add_btn_icon580.svg"),
          color: require("@/assets/images/add_icon/add_btn_icon581.svg"),
          hover: require("@/assets/images/add_icon/hover-iocn82.png"),
        },
      ],
      dataList: [],
    };
  },
  watch: {
    questionType: {
      handler(newVal) {
        console.log("fewfwe12ee12e12e12e12++++++++", newVal);

        if (newVal === 1) {
          this.dataList = this.wjComponents;
        } else if (newVal === 2) {
          this.dataList = this.ksComponents;
        } else if (newVal === 3) {
          this.dataList = this.cpComponents;
        } else {
          this.dataList = this.wjComponents;
        }
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    handleImportClick() {
      this.$emit("importClick");
    },
    async handleComponentClick(item, index) {
      this.$emit("componentClick", item, index);
    },
  },
};
</script>

<style lang="scss" scoped>
.components-panel {
  width: 200px;
  padding: 15px;
  border-right: 1px solid #e0e0e0;
  background: #f5f5f5;
}

.component-item {
  padding: 10px;
  margin-bottom: 10px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: move;
  user-select: none;
  transition: all 0.2s;
}

.component-item:hover {
  background: #e6f7ff;
  border-color: #1890ff;
}

.remove-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  background: #ff4d4f;
  color: white;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s;
}

.property-panel {
  width: 300px;
  padding: 15px;
  border-left: 1px solid #e0e0e0;
  background: white;
}

.property-panel h3 {
  margin-top: 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.property-panel label {
  display: block;
  margin: 15px 0 5px;
  font-weight: bold;
  color: #666;
}

.property-panel input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.form-control {
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.checkbox,
.radio {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.add_title {
  font-size: 18px;
  display: flex;
  justify-content: space-between;
}

.questionnaire_box .add_control .add_btn_list .btn_item .content {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/AddControl/index.vue